<template>
  <div class="base-event-name" :class="[eventColor, { isFilled }]">
    <div class="bar" />
    <span>{{ eventTitle }}</span>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    eventTitle: {
      type: String,
      required: true,
    },
    eventColor: {
      type: String,
      required: false,
    },
    isFilled: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
<style scoped lang="scss">
.base-event-name {
  @extend %font-body-regular;
  padding: 4px 12px;
  border-radius: 3px;
  position: relative;
  &:not(.isFilled) {
    border-width: 1px;
    border-style: solid;
  }
  &.isFilled {
    @extend %font-caption-medium;
  }
  @include themed() {
    color: t($primary);
    border-color: t($grey-50);
  }
  .bar {
    position: absolute;
    inset-inline-start: -1px;
    width: 3px;
    height: 20px;
    border-radius: 10px;
    @include themed() {
      background: t($grey-50);
    }
  }
  &.calendar-a--light {
    border-color: $calendar-a-50;
    color: $calendar-a-50;
  }
  &.calendar-a--dark {
    border-color: $calendar-a-80;
    color: $calendar-a-80;
  }
  &.calendar-b--light {
    border-color: $calendar-b-50;
    color: $calendar-b-50;
  }
  &.calendar-b--dark {
    border-color: $calendar-b-80;
    color: $calendar-b-80;
  }
  &.calendar-c--light {
    border-color: $calendar-c-50;
    color: $calendar-c-50;
  }
  &.calendar-c--dark {
    border-color: $calendar-c-80;
    color: $calendar-c-80;
  }
  &.calendar-d--light {
    border-color: $calendar-d-50;
    color: $calendar-d-50;
  }
  &.calendar-d--dark {
    border-color: $calendar-d-80;
    color: $calendar-d-80;
  }
  &.calendar-e--light {
    border-color: $calendar-e-50;
    color: $calendar-e-50;
  }
  &.calendar-e--dark {
    border-color: $calendar-e-80;
    color: $calendar-e-80;
  }
  &.calendar-f--light {
    border-color: $calendar-f-50;
    color: $calendar-f-50;
  }
  &.calendar-f--dark {
    border-color: $calendar-f-80;
    color: $calendar-f-80;
  }
  &.calendar-g--light {
    border-color: $calendar-g-50;
    color: $calendar-g-50;
  }
  &.calendar-g--dark {
    border-color: $calendar-g-80;
    color: $calendar-g-80;
  }
  &.calendar-h--light {
    border-color: $calendar-h-50;
    color: $calendar-h-50;
  }
  &.calendar-i--dark {
    border-color: $calendar-i-80;
    color: $calendar-i-80;
  }
  &.calendar-i--light {
    border-color: $calendar-i-50;
    color: $calendar-i-50;
  }
  &.calendar-h--dark {
    border-color: $calendar-h-80;
    color: $calendar-h-80;
  }
  &.calendar-i--light {
    border-color: $calendar-i-50;
  }
  &.calendar-i--dark {
    border-color: $calendar-i-80;
  }
  &.calendar-a--light .bar {
    background: $calendar-a-50;
  }
  &.calendar-a--dark .bar {
    background: $calendar-a-80;
  }
  &.calendar-b--light .bar {
    background: $calendar-b-50;
  }
  &.calendar-b--dark .bar {
    background: $calendar-b-80;
  }
  &.calendar-c--light .bar {
    background: $calendar-c-50;
  }
  &.calendar-c--dark .bar {
    background: $calendar-c-80;
  }
  &.calendar-d--light .bar {
    background: $calendar-d-50;
  }
  &.calendar-d--dark .bar {
    background: $calendar-d-80;
  }
  &.calendar-e--light .bar {
    background: $calendar-e-50;
  }
  &.calendar-e--dark .bar {
    background: $calendar-e-80;
  }
  &.calendar-f--light .bar {
    background: $calendar-f-50;
  }
  &.calendar-f--dark .bar {
    background: $calendar-f-80;
  }
  &.calendar-g--light .bar {
    background: $calendar-g-50;
  }
  &.calendar-g--dark .bar {
    background: $calendar-g-80;
  }
  &.calendar-h--light .bar {
    background: $calendar-h-50;
  }
  &.calendar-h--dark .bar {
    background: $calendar-h-80;
  }
  &.calendar-i--light .bar {
    background: $calendar-i-50;
  }
  &.calendar-i--dark .bar {
    background: $calendar-i-80;
  }
  &.isFilled {
    &.calendar-a--light {
      background: $calendar-a-20;
    }
    &.calendar-a--dark {
      background: $calendar-a-80;
    }
    &.calendar-b--light {
      background: $calendar-b-20;
    }
    &.calendar-b--dark {
      background: $calendar-b-80;
    }
    &.calendar-c--light {
      background: $calendar-c-20;
    }
    &.calendar-c--dark {
      background: $calendar-c-80;
    }
    &.calendar-d--light {
      background: $calendar-d-20;
    }
    &.calendar-d--dark {
      background: $calendar-d-20;
    }
    &.calendar-e--light {
      background: $calendar-e-20;
    }
    &.calendar-e--dark {
      background: $calendar-e-80;
    }
    &.calendar-f--light {
      background: $calendar-f-20;
    }
    &.calendar-f--dark {
      background: $calendar-f-80;
    }
    &.calendar-g--light {
      background: $calendar-g-20;
    }
    &.calendar-g--dark {
      background: $calendar-g-80;
    }
    &.calendar-h--light {
      background: $calendar-h-20;
    }
    &.calendar-h--dark {
      background: $calendar-h-80;
    }
    &.calendar-i--light {
      background: $calendar-i-20;
    }
    &.calendar-i--dark {
      background: $calendar-i-80;
    }
  }
}
</style>
